<template>
  <div class="lottery">
    <div class="lottery_k" v-if="choujiang">
      <div class="lottery_k_hb">
        <img class="lottery_k_hb_dt" src="../assets/img/cj.png">
        <div class="lottery_k_hb_hb">
          <img src="../assets/img/hb.png" id="t">
        </div>
        <div class="lottery_k_hb_w">
          <div class="lottery_k_hb_w_b">
            <span v-if="wen">感谢您<br>对医保工作的关注与支持</span>
            <span v-if="winprize">很遗憾<br>没有中奖</span>
            <span v-if="prize">恭喜您<br>获得<em>{{money}}元</em>红包</span>
          </div>
          <div class="lottery_k_hb_w_d" v-if="cj" @click="gaibiao">
            <span>去抽红包</span>
          </div>
          <div class="lottery_k_hb_w_d" v-if="fx" @click="fenxiang">
            <span>分享给好友</span>
          </div>
        </div>
      </div>
    </div>
    <div class="lottery_fx" v-if="djfenxiang">
      <img src="../assets/img/share_tisp.png">
    </div>
  </div>
</template>
<script>
import CryptoJS from 'crypto-js';
export default {
  data () {
    return {
      wen:true,
      winprize:false,
      prize:false,
      cj:true,
      fx:false,
      money:0,
      djfenxiang:false,
      choujiang:true,
    }
  },
  components: {
  },
  created(){
   
  },
  beforeMount(){
    
  },
  mounted(){
    // this.draw_num = 1;
    // this.prize_id = window.localStorage.getItem('prize_id');
    // this.getData();
  },
  methods:{
    // 加密
    encrypt(data) {
      const key = CryptoJS.enc.Latin1.parse('e7b1b3e5a49ae88a');
      // console.log("key:",key);
      const iv = CryptoJS.enc.Latin1.parse('e69d8ee68b9ce5a4');
    // console.log('iv',iv)
    const Base64 = require('js-base64').Base64
      data = Base64.encode(data)
      // console.log('data',data);
      data = CryptoJS.AES.encrypt(data, key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          adding: CryptoJS.pad.ZeroPadding
      }).toString()
      // console.log('data11111111', data)
      return Base64.encode(data)
    },
    gaibiao(){
      let cjang = {
        dgybwj_check_params:1
      }
      let data = this.encrypt(JSON.stringify(cjang))
      this.$http.get(`${this.service}questionnaire/draw?access-token=${this.$store.state.access_token}`,{
        data
      }).then((datas)=>{
        console.log(datas,'抽奖')
        if(datas.is_award==1){
          this.prize = !this.prize;
          this.wen = !this.wen;
          this.money = datas.money;
        }else{
          this.wen = !this.wen;
          this.winprize = !this.winprize;
        }
        document.getElementById("t").style.top="0";
        this.cj = !this.cj;
        this.fx = !this.fx;
      })
    },
    fenxiang(){
      this.djfenxiang = !this.djfenxiang;
      this.choujiang = !this.choujiang;
      // this.$emit('share')
    },
  }
}
</script>

<style scoped lang="less">
@import '../assets/css/less.less';
.lottery{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  .lottery_k{
    width: 588/@r;
    display: block;
    margin: 0;
    position: relative;
    .lottery_k_hb{
      width: 100%;
      height: 6.66rem;
      position: relative;
      .lottery_k_hb_dt{
        width: 100%;
        height: 100%;
        display: block;
      }
      .lottery_k_hb_hb{
        width: 1.32rem;
        height: 1.24rem;
        position: absolute;
        top: 2.39rem;
        left: 50%;
        transform: translateX(-50%);
        overflow: hidden;
        img{
          width: 100%;
          height: 100%;
          display: block;
          position: relative;
          top: 100%;
          -webkit-transition:all .2s ease;-moz-transition:all .2s ease;-o-transition:all .2s ease;transition:all .2s ease;
        }
      }
      .lottery_k_hb_w{
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 2;
        top: 0;
        left: 0;
        .lottery_k_hb_w_b{
          width: 100%;
          text-align: center;
          font-size: 48/@r;
          color: #fff;
          font-weight: bold;
          line-height: 1rem;
          padding-top: 20/@r;
          span{
            font-family: 'heavy';
          }
        }
        .lottery_k_hb_w_d{
          width: 409/@r;
          height: 99/@r;
          position: absolute;
          bottom: 57/@r;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          align-items: center;
          justify-content: center;
          span{
            font-size: 40/@r;
            color: #b84a34;
            letter-spacing: 0.05rem;
            text-indent: 0.05rem;
            font-weight: 400;
          }
        }
      }
    }
  }
  .lottery_fx{
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    img{
      width: 5.48rem;
      height: 4.6rem;
      position: absolute;
      right: .866667rem;
      top: .266667rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/lottery.vue